export const webEntries = [
  { path: '/farmRunningStatus', title: '运行状态', icon: 'el-icon-data-analysis', admin: true },
  { path: '/users', title: '账号管理', icon: 'el-icon-user', admin: true },
  { path: '/dispatchCenter', title: '调度中心', icon: 'el-icon-connection', button: '1', business: true },
  { path: '/irrigationPlans', title: '轮灌计划', icon: 'el-icon-date', button: '2' },
  { path: '/waterFertilizerScheme', title: '水肥方案', icon: 'el-icon-s-operation', button: '3' },
  { path: '/farmingRecords', title: '农事记录', icon: 'el-icon-notebook-2', button: '4' },
  { path: '/patrolRecords', title: '巡田记录', icon: 'el-icon-document-checked', button: '5' },
  { path: '/expertDecision', title: '专家决策', icon: 'el-icon-reading', button: '6' }
]
export function availableEntries(session) {
  const buttons = String(session && session.profile && session.profile.appButtons || '').split(',').map(value => value.trim())
  return webEntries.filter(item => item.admin ? session && session.level === 2 : buttons.includes(item.button))
}

export function safeWebRedirect(router, value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/web/home'
  const route = router.resolve(value).route
  if (!route.matched.length || ['/login', '/'].includes(route.path)) return '/web/home'
  const query = { ...route.query }
  query.webApp = '1'
  delete query.os
  delete query.redirect
  delete query.webtitle
  return { path: route.path, query, hash: route.hash }
}
